import * as type from '../actions/types';

const initialState = {
  data: [],
  forceAccommodationSelection: false,
  requireExperienceSelection: false,
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_EXPERIENCES_PENDING: {
      return {
        ...state,
        error: '',
        pending: true,
        success: false,
      };
    }

    case type.FETCH_EXPERIENCES_SUCCESS: {
      return {
        ...state,
        data: action.payload.data?.experiences ?? [],
        forceAccommodationSelection: action.payload.data?.forceAccommodationSelection ?? false,
        requireExperienceSelection: action.payload.data?.requireExperienceSelection ?? false,
        pending: false,
        success: true,
      };
    }

    case type.FETCH_EXPERIENCES_FAILURE: {
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
